import {getLearningCenterConsent} from '~/app/utils/helpers'
import queryString from 'query-string'
import {useCookieTracker} from '~/app/utils/cookieTracking/CookieTrackerProvider'
import {useLocation} from 'react-router-dom'

const useLearningCenterConsent = () => {
    const {cookieValues} = useCookieTracker()
    const location = useLocation()

    const hasRespondedtoConsentModal = () => {
        return getLearningCenterConsent() !== null
    }
    const needsLearningCenterTPAConsent = () => {
        const queryParams = queryString.parse(location.search)
        const needslearningCenterConsent =
            typeof queryParams?.AFID !== 'undefined' ||
            typeof queryParams?.afid !== 'undefined' ||
            typeof cookieValues?.tpaBranding?.afid !== 'undefined' ||
            false
        return needslearningCenterConsent
    }

    return {
        hasRespondedtoConsentModal,
        needsLearningCenterTPAConsent
    }
}

export default useLearningCenterConsent
